var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 3.91072C17.875 3.07737 18.6025 2.40179 19.5 2.40179C20.3975 2.40179 21.125 3.07737 21.125 3.91072V5.41965H32.5C33.3975 5.41965 34.125 6.09523 34.125 6.92858C34.125 7.76193 33.3975 8.43751 32.5 8.43751H6.5C5.60254 8.43751 4.875 7.76193 4.875 6.92858C4.875 6.09523 5.60254 5.41965 6.5 5.41965H17.875V3.91072Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 9.94641C15.3525 9.94641 14.625 10.622 14.625 11.4553V25.0357C14.625 25.8691 15.3525 26.5446 16.25 26.5446C17.1475 26.5446 17.875 25.8691 17.875 25.0357V11.4553C17.875 10.622 17.1475 9.94641 16.25 9.94641Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 11.4553C21.125 10.622 21.8525 9.94641 22.75 9.94641C23.6475 9.94641 24.375 10.622 24.375 11.4553V25.0357C24.375 25.8691 23.6475 26.5446 22.75 26.5446C21.8525 26.5446 21.125 25.8691 21.125 25.0357V11.4553Z",
    fill: "#C0C0C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 11.4553C8.125 10.622 8.85255 9.94641 9.75 9.94641C10.6475 9.94641 11.375 10.622 11.375 11.4553V29.5625H27.625V11.4553C27.625 10.622 28.3525 9.94641 29.25 9.94641C30.1475 9.94641 30.875 10.622 30.875 11.4553V31.0714C30.875 31.9048 30.1475 32.5803 29.25 32.5803H9.75C8.85255 32.5803 8.125 31.9048 8.125 31.0714V11.4553Z",
    fill: "#C0C0C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.311411f41d0f97a463bd23a6154ddac1.svg";
export { ForwardRef as ReactComponent };